/**
 * ItemGo Firebase Configuration
 * Supports emulator in development, production in build
 */
import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getMessaging } from 'firebase/messaging';
import { getAnalytics } from 'firebase/analytics';
// Default config for emulator (override with env in production)
const firebaseConfig = {
    apiKey: import.meta.env?.VITE_FIREBASE_API_KEY || 'demo-api-key',
    authDomain: import.meta.env?.VITE_FIREBASE_AUTH_DOMAIN || 'demo-project.firebaseapp.com',
    projectId: import.meta.env?.VITE_FIREBASE_PROJECT_ID || 'demo-itemgo',
    storageBucket: import.meta.env?.VITE_FIREBASE_STORAGE_BUCKET || 'demo-project.appspot.com',
    messagingSenderId: import.meta.env?.VITE_FIREBASE_MESSAGING_SENDER_ID || '123456789',
    appId: import.meta.env?.VITE_FIREBASE_APP_ID || '1:123456789:web:abcdef',
    measurementId: import.meta.env?.VITE_FIREBASE_MEASUREMENT_ID || 'G-S117BNG1KK',
};
const isDev = typeof import.meta !== 'undefined' && import.meta.env?.VITE_USE_EMULATOR === 'true';
const isTest = typeof import.meta !== 'undefined' && import.meta.env?.MODE === 'test';
let app;
let db;
let auth;
let functions;
let storage;
let messaging;
let analytics;
function getEmulatorHost() {
    // If explicitly set via env, use it
    if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_FIREBASE_EMULATOR_HOST) {
        return import.meta.env.VITE_FIREBASE_EMULATOR_HOST;
    }
    // In browser, detect the actual server hostname (for local network access)
    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname;
        // Use the server's IP/hostname if accessing via network (not localhost)
        if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
            return hostname;
        }
    }
    return 'localhost';
}
export function initializeFirebase() {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    functions = getFunctions(app);
    storage = getStorage(app);
    try {
        messaging = getMessaging(app);
    }
    catch {
        messaging = undefined;
        // FCM not supported in this browser (e.g., no service worker support, HTTP context)
    }
    db = getFirestore(app);
    if (typeof window !== 'undefined' && firebaseConfig.measurementId) {
        try {
            analytics = getAnalytics(app);
        }
        catch (err) {
            console.warn('[Firebase] Analytics failed to initialize:', err);
        }
    }
    if (isDev || isTest) {
        const emulatorHost = getEmulatorHost();
        connectFirestoreEmulator(db, emulatorHost, 8080);
        connectAuthEmulator(auth, `http://${emulatorHost}:9099`, { disableWarnings: true });
        connectFunctionsEmulator(functions, emulatorHost, 5001);
        connectStorageEmulator(storage, emulatorHost, 9199);
        console.log('[Firebase] Connected to emulators at', emulatorHost);
    }
}
export { app, db, auth, functions, storage, messaging, analytics };
//# sourceMappingURL=config.js.map